import ApiServiceWrapper from './../../api-request.service';
import { MswApiStatusResponse } from '@/shared/types/api-common-types';
import { StoreInputParameters } from '@/services/idbStore.interface';
import idb, { USERGROUP_STORE_NAME, TENANTS_STORE_NAME } from '@/services/indexedDb.service';
import store from '@/store';
const endpointProduct = 'products/';
const endpointPrefixUsers = 'users/';
let lastCalledUserGroupId = '';
const createCustomerApi = {
  postNewCustomer(addNewCustomer: any) {
    const data = {
      productGroup: addNewCustomer.productGroup,
      partyGroupId: addNewCustomer.partyGroupId ? addNewCustomer.partyGroupId : '' ,
      userGrpName : addNewCustomer.userGrpName,
      source: addNewCustomer.source ? addNewCustomer.source : '' ,
      isAddressVerified : addNewCustomer.isAddressVerified ? addNewCustomer.isAddressVerified : 'FALSE',
      isAddressVerificationCompleted : addNewCustomer.isAddressVerificationCompleted ? addNewCustomer.isAddressVerificationCompleted : '',
      tenantAddress : addNewCustomer.tenantAddress ? addNewCustomer.tenantAddress : '',
    };
    const reqEndPoint = `${endpointProduct}create-product-group`;
    window.parent.postMessage({
      reloadCSC : true,
    },                        '*');
    return ApiServiceWrapper.post<MswApiStatusResponse>(reqEndPoint, data);
  },
  // getUserGroup() {
  //   const reqEndPoint = `${endpointPrefixUsers}get-usergroup-details-for-user`;
  //   return ApiServiceWrapper.get(`${reqEndPoint}`);
  // },
  async getUserGroup(forced = false) {
    console.warn('get data ');
    let endpoint = `${endpointPrefixUsers}get-usergroup-details-for-user`;
    if (forced) {
      endpoint += '?isForced=true';
    }
    console.warn(store.getters.isLargeCustomer);
    if (!store.getters.isLargeCustomer) {
      const apiData = await (ApiServiceWrapper.get(endpoint));
      return apiData;
    }
    const request: StoreInputParameters = { endpoint, payload: {}, forceFetch: forced, objectName: USERGROUP_STORE_NAME, httpMethod: 'get' };
    const idbData = await idb.getData(request, ['MSWAPP:LISTUSERGROUPSUCCESS'], '');
    return Promise.resolve(idbData);
  },
  getUserGroupPermissions(partyGroupId: string) {
    const reqEndPoint = `${endpointPrefixUsers}GetUserGroupPermissions?partygroupid=${partyGroupId}`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  postManageProductUserGroups(data: any) {
    const reqEndPoint = `${endpointPrefixUsers}manage-product-user-group`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(reqEndPoint, data);
  },
  postManageUserProductGroup(data:any) {
    const reqEndPoint = `${endpointPrefixUsers}manage-party-product-group`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(reqEndPoint, data);
  },
  getProductGroupDetails() {
    const reqEndPoint = `${endpointPrefixUsers}get-productgroup-details`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  async saveProductsDetailList({}, payload : any) {
    await idb.saveData(TENANTS_STORE_NAME, payload);
    return;
  },
  async saveUserGroupList({}, payload : any) {
    await idb.saveData(USERGROUP_STORE_NAME, payload);
    return;
  },
  changePermssion(id: string, value: string, productname: string) {
    const reqEndPoint = `${endpointPrefixUsers}save-User-Group-Permissions?partygroupid=${id}&choiceid=${value}&productname=${productname}`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  createUserGroup(name: string, id: string) {
    const reqEndPoint = `${endpointPrefixUsers}create-user-group?newUserGroup=${name}&productGroupId=${id}`;
    return ApiServiceWrapper.post(`${reqEndPoint}`);
  },
  editUserGroup(data: any) {
    const reqEndPoint = `${endpointPrefixUsers}rename-user-group`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  deleteUserGroup(data: any) {
    const reqEndPoint = `${endpointPrefixUsers}delete-usergroup`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  async listUsersForUserGroup(userGroupId: string) {
    const endpoint : string = `${endpointPrefixUsers}list-users-for-usergroup?userGroupId=${userGroupId}`;
    // tslint:disable-next-line:max-line-length
    const request: StoreInputParameters = { endpoint, payload: {}, forceFetch: lastCalledUserGroupId === userGroupId ? false : true , objectName: 'savedUserList', httpMethod: 'get' };
    const idbData = await idb.getData(request, ['MSWAPP:LISTUSERGROUPSUCCESS', 'MSWAPP:LISTUSERSFORUSERGROUPUCCESS'], '');
    lastCalledUserGroupId = userGroupId;
    return Promise.resolve(idbData);
  },
  manageUsers(data: any) {
    const reqEndPoint = `${endpointPrefixUsers}manage-users`;
    lastCalledUserGroupId = '';
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  getProductGroupList(payload : any) {
    let reqEndPoint = '';
    if (payload === 'createCustomer' || payload === 'userGroup') {
      reqEndPoint = `${endpointPrefixUsers}get-productgroup-details-for-user?isforced=true&skipProducts=YES`;
    } else {
      reqEndPoint = `${endpointPrefixUsers}get-productgroup-details-for-user?isforced=true`;
    }
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  manageDefaultGroup(data: any) {
    const reqEndPoint = `${endpointPrefixUsers}manage-default-groups`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, data);
  },
  addUsers(data: any, booleanVal:boolean) {
    const reqEndPoint = `${endpointPrefixUsers}add-user`;
    let req = {};
    if (booleanVal) {
      req = {
        masterMsspId: data.masterMsspId,
        emailAddress: data.emailAddress,
        firstName: data.firstName,
        lastName: data.lastName,
        partyGroupId: data.partyGroupId,
        contactTypeId: data.contactTypeId,
        bskipResellerCustomerValidation: true,
      };
    } else {
      req = {
        masterMsspId: data.masterMsspId,
        emailAddress: data.emailAddress,
        firstName: data.firstName,
        lastName: data.lastName,
        partyGroupId: data.partyGroupId,
        contactTypeId: data.contactTypeId,
        bskipResellerCustomerValidation: false,
      };
    }
    return ApiServiceWrapper.post(`${reqEndPoint}`, req);
  },
  deleteContact(req: any) {
    const reqEndPoint = `${endpointPrefixUsers}delete-contact`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, req);
  },
  viewOrRevokeOrGrant(req: any) {
    const reqEndPoint = `${endpointPrefixUsers}manage-apikey`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, req);
  },
  listProductGroupForUserGroup(id: string) {
    const reqEndPoint = `${endpointPrefixUsers}list-productGroups-for-usergroup?userGroupId=${id  }`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  createUserGrp(name: string, productGroupId: string) { // without productGroup
    const reqEndPoint = `${endpointPrefixUsers}create-user-group?newUserGroup=${name}&productGroupId=${productGroupId}`;
    return ApiServiceWrapper.post(`${reqEndPoint}`);
  },
  renameProductGroup(obj: any) {
    const reqEndPoint = `${endpointPrefixUsers}rename-product-group`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, obj);
  },
  deleteProductGroup(obj: any) {
    window.parent.postMessage({
      reloadCSC : true,
    },                        '*');
    const reqEndPoint = `${endpointPrefixUsers}delete-productgroup`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, obj);
  },
  searchTenant(searchedValue: any) {
    const reqEndPoint = `${endpointProduct}search-tenant?tenantName=${searchedValue}`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  searchUserGroupInApi(searchedValue: any) {
    const reqEndPoint = `${endpointPrefixUsers}search-usergroup?userGroupName=${searchedValue}`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  transferTenant(payload: any) {
    const reqEndPoint = 'product/Initiate-Tenant-Transfer';
    return ApiServiceWrapper.post(`${reqEndPoint}`, payload);
  },
};

export default createCustomerApi;
